import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Typography } from "@plum-xoxo/admin-dsm";

const Reward_Send_Data = {
  1: [
    {
      label: "What are Reward Points?",
      link: "https://helpcenter.xoxoday.com/docs/reward-modes-and-types",
    },
    {
      label: "Learn more",
      link: "https://helpcenter.xoxoday.com/docs/reward-points",
    },
  ],
  2: [
    {
      label: "What are Reward Codes?",
      link: "https://helpcenter.xoxoday.com/docs/reward-modes-and-types",
    },
    {
      label: "Learn more",
      link: "https://helpcenter.xoxoday.com/docs/about-reward-code",
    },
  ],
  3: [
    {
      label: "What are Reward Links?",
      link: "https://helpcenter.xoxoday.com/docs/reward-modes-and-types",
    },
    {
      label: "Learn more",
      link: "https://helpcenter.xoxoday.com/docs/reward-link",
    },
  ],
  4: [
    {
      label: "What are Gift Cards?",
      link: "https://helpcenter.xoxoday.com/docs/reward-modes-and-types",
    },
    {
      label: "Learn more",
      link: "https://helpcenter.xoxoday.com/docs/brand-vouchers",
    },
  ],
};

const StyledDiv = styled.div`
  width: 200px;
  padding-top: 12px;
`;

const WhomToSend = ({ reward_type }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    setData(Reward_Send_Data[reward_type]);
  }, []);

  return (
    <StyledDiv>
      <Typography.LabelText className="mb-16">Get Help</Typography.LabelText>
      {data &&
        data.map((ele, index) => (
          <a
            href={ele.link}
            key={index}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Typography.BodySmall color="primary" shade="c02">
              {ele.label}
            </Typography.BodySmall>
          </a>
        ))}
    </StyledDiv>
  );
};

export default WhomToSend;
